import { Alert } from '@a-ui/react';
import React from 'react';
import { translate } from '../../i18n';
import Typography from '../Typography';

interface PhoneFormInfoboxProps {
  form: any;
  user: Api.User;
}

const PhoneFormInfobox: React.FC<PhoneFormInfoboxProps> = ({ form, user }) => {
  return (
    <Alert className="u-margin-bottom-xs">
      <Typography>
        {translate('accessKeys.phone.form.step2.intro', {
          phone: (
            <b>{form?.current?.values.phoneNumber || user.phone?.candidate}</b>
          ) as unknown as string,
        })}
      </Typography>
    </Alert>
  );
};

export default PhoneFormInfobox;
